function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5729"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5729"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $b334bd26f6bb316b$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"kb9mm":"index.51b488a3.js","h9mCZ":"CY.10e38e25.webp","cFxfC":"CN.f88e3e46.webp","2tM1y":"NP.0b72b784.webp"}'));

// create array of [flag='XX'], populate canvas with flags, each one with the corresponding array index as attribute, e.g.
// <div index='1' />
// when clicking or hovering the div flag, the corresponding index in the array will change to 'BR' or 'CN' for instance
const $b63be9b0371e788c$var$canvas = document.querySelector(".canvas");
const $b63be9b0371e788c$var$currentFlag = document.querySelector(".current .flag");
const $b63be9b0371e788c$var$linesInput = document.querySelector("[type=number]");
const $b63be9b0371e788c$var$selectBrush = document.querySelector("[name=brush]");
const $b63be9b0371e788c$var$selectPaint = document.querySelector("[name=paint]");
const $b63be9b0371e788c$var$copyButton = document.querySelector(".copy");
const $b63be9b0371e788c$var$resetButton = document.querySelector(".reset");
const $b63be9b0371e788c$var$textarea = document.querySelector("textarea");
var $aeafa53f542d18e5$exports = {};

$aeafa53f542d18e5$exports = new URL((parcelRequire("27Lyk")).resolve("h9mCZ"), import.meta.url).toString();


var $a83570bd18cc15a6$exports = {};

$a83570bd18cc15a6$exports = new URL((parcelRequire("27Lyk")).resolve("cFxfC"), import.meta.url).toString();


var $45d161bda320bfd4$exports = {};

$45d161bda320bfd4$exports = new URL((parcelRequire("27Lyk")).resolve("2tM1y"), import.meta.url).toString();


const $b63be9b0371e788c$var$flagFileNames = [
    "AD.gif",
    "AE.gif",
    "AF.gif",
    "AFR.gif",
    "AG.gif",
    "AL.gif",
    "AM.gif",
    "AO.gif",
    "AR.gif",
    "AS.gif",
    "ASIA.gif",
    "AT.gif",
    "AU.gif",
    "AW.gif",
    "AZ.gif",
    "BA.gif",
    "BB.gif",
    "BD.gif",
    "BE.gif",
    "BF.gif",
    "BG.gif",
    "BH.gif",
    "BI.gif",
    "BJ.gif",
    "BM.gif",
    "BN.gif",
    "BO.gif",
    "BR.gif",
    "BS.gif",
    "BT.gif",
    "BW.gif",
    "BY.gif",
    "BZ.gif",
    "CA.gif",
    "CD.gif",
    "CF.gif",
    "CG.gif",
    "CH.gif",
    "CI.gif",
    "CK.gif",
    "CL.gif",
    "CM.gif",
    "CN.gif",
    "CO.gif",
    "CR.gif",
    "CU.gif",
    "CV.gif",
    "CY.gif",
    "CZ.gif",
    "DE.gif",
    "DJ.gif",
    "DK.gif",
    "DM.gif",
    "DO.gif",
    "DZ.gif",
    "EC.gif",
    "EE.gif",
    "EG.gif",
    "ENG.gif",
    "ER.gif",
    "ES.gif",
    "ET.gif",
    "EU.gif",
    "FI.gif",
    "FJ.gif",
    "FO.gif",
    "FR.gif",
    "GA.gif",
    "GB.gif",
    "GD.gif",
    "GE.gif",
    "GH.gif",
    "GL.gif",
    "GM.gif",
    "GN.gif",
    "GQ.gif",
    "GR.gif",
    "GT.gif",
    "GU.gif",
    "GW.gif",
    "GY.gif",
    "HK.gif",
    "HN.gif",
    "HR.gif",
    "HT.gif",
    "HU.gif",
    "ID.gif",
    "IE.gif",
    "IL.gif",
    "IN.gif",
    "IQ.gif",
    "IR.gif",
    "IS.gif",
    "IT.gif",
    "JM.gif",
    "JO.gif",
    "JP.gif",
    "KE.gif",
    "KG.gif",
    "KH.gif",
    "KM.gif",
    "KN.gif",
    "KR.gif",
    "KW.gif",
    "KY.gif",
    "KZ.gif",
    "LB.gif",
    "LC.gif",
    "LI.gif",
    "LK.gif",
    "LR.gif",
    "LS.gif",
    "LT.gif",
    "LU.gif",
    "LV.gif",
    "LY.gif",
    "MA.gif",
    "MC.gif",
    "MD.gif",
    "ME.gif",
    "MG.gif",
    "MK.gif",
    "ML.gif",
    "MM.gif",
    "MN.gif",
    "MO.gif",
    "MR.gif",
    "MT.gif",
    "MU.gif",
    "MV.gif",
    "MW.gif",
    "MX.gif",
    "MY.gif",
    "NA.gif",
    "NAM.gif",
    "NE.gif",
    "NG.gif",
    "NI.gif",
    "NL.gif",
    "NO.gif",
    "NP.gif",
    "NZ.gif",
    "OCE.gif",
    "OM.gif",
    "PA.gif",
    "PE.gif",
    "PG.gif",
    "PH.gif",
    "PK.gif",
    "PL.gif",
    "PR.gif",
    "PS.gif",
    "PT.gif",
    "PY.gif",
    "QA.gif",
    "RE.gif",
    "RO.gif",
    "RS.gif",
    "RU.gif",
    "RW.gif",
    "SA.gif",
    "SAM.gif",
    "SB.gif",
    "SC.gif",
    "SCT.gif",
    "SD.gif",
    "SE.gif",
    "SG.gif",
    "SI.gif",
    "SK.gif",
    "SL.gif",
    "SM.gif",
    "SN.gif",
    "SO.gif",
    "SR.gif",
    "SS.gif",
    "ST.gif",
    "SV.gif",
    "SY.gif",
    "SZ.gif",
    "TD.gif",
    "TG.gif",
    "TJ.gif",
    "TL.gif",
    "TM.gif",
    "TN.gif",
    "TO.gif",
    "TR.gif",
    "TT.gif",
    "TW.gif",
    "TZ.gif",
    "UA.gif",
    "UG.gif",
    "US.gif",
    "UY.gif",
    "UZ.gif",
    "VC.gif",
    "VE.gif",
    "VG.gif",
    "VI.gif",
    "VN.gif",
    "VU.gif",
    "WLS.gif",
    "WORLD.gif",
    "WS.gif",
    "XK.gif",
    "YE.gif",
    "YU.gif",
    "ZA.gif",
    "ZM.gif",
    "ZW.gif"
];
let $b63be9b0371e788c$var$canvasLines = 17;
let $b63be9b0371e788c$var$canvasHeight = $b63be9b0371e788c$var$canvasLines * 26;
let $b63be9b0371e788c$var$flagsArray = [
    "flag=CY",
    "flag=CN",
    "flag=CY"
];
let $b63be9b0371e788c$var$brush = "CN";
let $b63be9b0371e788c$var$background = "CY";
function $b63be9b0371e788c$var$createFlag(flag, index) {
    const img = document.createElement("img");
    img.classList.add("flag");
    img.setAttribute("src", `https://www.hltv.org/img/static/flags/30x20/${flag}.gif`);
    img.setAttribute("index", index);
    return img;
}
function $b63be9b0371e788c$var$updateTextArea() {
    $b63be9b0371e788c$var$textarea.innerText = $b63be9b0371e788c$var$flagsArray.join("");
}
function $b63be9b0371e788c$var$populateFlagsArray(flag, qty) {
    // if (cleanUpArray) flagsArray.length = 0;
    $b63be9b0371e788c$var$flagsArray.splice(0, Number.MAX_SAFE_INTEGER);
    for(let i = 0; i < qty; i++)$b63be9b0371e788c$var$flagsArray.push(`[flag=${flag}]`);
    $b63be9b0371e788c$var$updateTextArea();
    $b63be9b0371e788c$var$populateFlags();
    $b63be9b0371e788c$var$addImgEventHandler();
}
function $b63be9b0371e788c$var$changeBackground(flag, i) {
    $b63be9b0371e788c$var$flagsArray = $b63be9b0371e788c$var$flagsArray.map((f)=>{
        if (f === `[flag=${$b63be9b0371e788c$var$background}]`) return `[flag=${$b63be9b0371e788c$var$selectPaint.value}]`;
        return f;
    });
    $b63be9b0371e788c$var$background = $b63be9b0371e788c$var$selectPaint.value;
    $b63be9b0371e788c$var$updateTextArea();
    $b63be9b0371e788c$var$populateFlags();
    $b63be9b0371e788c$var$addImgEventHandler();
}
function $b63be9b0371e788c$var$populateFlags() {
    $b63be9b0371e788c$var$canvas.innerHTML = "";
    $b63be9b0371e788c$var$flagsArray.forEach((txt, i)=>{
        const flag = txt.split("=")[1].replace("]", "");
        const img = $b63be9b0371e788c$var$createFlag(flag, i);
        $b63be9b0371e788c$var$canvas.append(img);
    });
}
function $b63be9b0371e788c$var$populateSelect(selectElement) {
    $b63be9b0371e788c$var$flagFileNames.forEach((filename)=>{
        const abbreviation = filename.split(".")[0];
        const option = document.createElement("option");
        option.value = abbreviation;
        option.innerText = abbreviation;
        selectElement.append(option);
    });
}
function $b63be9b0371e788c$var$addImgEventHandler() {
    const imgs = document.querySelectorAll(".flag");
    imgs.forEach((img)=>{
        img.addEventListener("mouseenter", ()=>{
            const index = img.attributes.index.value;
            img.src = `https://www.hltv.org/img/static/flags/30x20/${$b63be9b0371e788c$var$brush}.gif`;
            $b63be9b0371e788c$var$flagsArray[index] = `[flag=${$b63be9b0371e788c$var$brush}]`;
            $b63be9b0371e788c$var$updateTextArea();
        });
    });
}
// Populate flags on canvas
$b63be9b0371e788c$var$populateFlagsArray($b63be9b0371e788c$var$selectPaint.value, $b63be9b0371e788c$var$canvasHeight);
//set default current flag
$b63be9b0371e788c$var$currentFlag.src = `https://www.hltv.org/img/static/flags/30x20/${$b63be9b0371e788c$var$brush}.gif`;
// add event handlers
// POPULATE SELECT DROPDOWNS
$b63be9b0371e788c$var$populateSelect($b63be9b0371e788c$var$selectBrush);
$b63be9b0371e788c$var$populateSelect($b63be9b0371e788c$var$selectPaint);
$b63be9b0371e788c$var$linesInput.value = $b63be9b0371e788c$var$canvasLines;
$b63be9b0371e788c$var$selectBrush.onchange = (e)=>{
    $b63be9b0371e788c$var$brush = e.target.value;
    console.log(e.target.value);
    $b63be9b0371e788c$var$currentFlag.src = `https://www.hltv.org/img/static/flags/30x20/${e.target.value}.gif`;
};
$b63be9b0371e788c$var$selectPaint.onchange = (e)=>{
    $b63be9b0371e788c$var$changeBackground($b63be9b0371e788c$var$selectPaint.value);
// populateFlagsArray(e.target.value, canvasHeight);
};
// ADD EVENT LISTENERS TO WINDOW TO PAINT/STOP PAINTING
window.addEventListener("mousedown", ()=>{
    $b63be9b0371e788c$var$canvas.style.pointerEvents = "all";
});
window.addEventListener("mouseup", ()=>{
    $b63be9b0371e788c$var$canvas.style.pointerEvents = "none";
});
$b63be9b0371e788c$var$copyButton.onclick = async ()=>{
    await navigator.clipboard.writeText($b63be9b0371e788c$var$flagsArray.join(""));
    alert("Text Copied");
};
$b63be9b0371e788c$var$resetButton.onclick = ()=>{
    $b63be9b0371e788c$var$populateFlagsArray($b63be9b0371e788c$var$selectPaint.value, $b63be9b0371e788c$var$canvasHeight);
};
$b63be9b0371e788c$var$linesInput.onchange = (e)=>{
    $b63be9b0371e788c$var$canvasHeight = Number(e.target.value) * 26;
    $b63be9b0371e788c$var$populateFlagsArray($b63be9b0371e788c$var$selectPaint.value, $b63be9b0371e788c$var$canvasHeight);
};


//# sourceMappingURL=index.51b488a3.js.map
